import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { ClerkProvider } from "@clerk/clerk-react";
import { App } from "./App";

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("missing #root");

createRoot(rootEl).render(
  <StrictMode>
    <ClerkProvider publishableKey={__CLERK_PUBLISHABLE_KEY__}>
      <App />
    </ClerkProvider>
  </StrictMode>,
);
